import { Mutation, Visitor } from 'graphql/generated/graphqlTypes';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';

export function mockedSetVisitorByIdData(setVisitorById: Visitor): Pick<Mutation, 'setVisitorById'> {
  return {
    setVisitorById
  };
}

export const mockedSetVisitorDataForMutation = mockedSetVisitorByIdData(
  generateMockVisitor({ id: 'mockedExternalUserId' })
);

export const mockedSetVisitorDataForMutation1 = mockedSetVisitorByIdData(
  generateMockVisitor({
    id: 'mockedVisitorIdExternalUser6',
    name: 'mockedVisitorEmailExternalUser6Edited',
    email: 'mockedVisitorEmailExternalUser6'
  })
);

export const mockedUpdateInstallerDataForMutation = mockedSetVisitorByIdData(
  generateMockVisitor({
    id: 'mockedVisitorIdInstaller1',
    name: 'mockedVisitorNameInstaller1Updated',
    email: 'mockedVisitorEmailInstaller1'
  })
);
